import { render } from "./DTInput.vue?vue&type=template&id=2e04a9c4&scoped=true"
import script from "./DTInput.vue?vue&type=script&lang=js"
export * from "./DTInput.vue?vue&type=script&lang=js"

import "./DTInput.vue?vue&type=style&index=0&id=2e04a9c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e04a9c4"]])

export default __exports__